

















































import InfoUser from "@/components/InfoUser.vue";
import PaymentDetail from "@/components/PaymentDetail.vue";
import Card from "@/components/Card.vue";
import PaymentBase from "./PaymentBase";
import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import ModalBase from "@/components/ModalBase.vue";
import { getformattedLocale } from "@/i18n";

const AUTHENTICATION_REASONS_MAP: any = {
    SUCCESSFUL: true,
    ATTEMPTED: true,
    BYPASSED: true,
    UNAVAILABLE: true,
    ERROR: false, // Reinit Form
    CARD_INELIGIBLE: true,
    SKIPPED_BY_BUYER: false,
    FAILURE: false,
    undefined: true,
};

@Component({
    components: {
        Card,
        ModalBase,
    },
})
export default class PaypalCardPay extends PaymentBase {
    @Prop() readonly payment!: Checkout;

    card: any = null;
    processing: boolean = false;
    eligible: any = window.paypal.HostedFields.isEligible();
    error: any = null;
    paypalActions: any = null;
    hostedFields: any = null;
    cardHolderName: string = "";
    isPaypalDataValid: boolean = false;
    cvvInfoVisible: boolean = false;

    get isFormValid() {
        return this.isPaypalDataValid && this.cardHolderName && this.cardHolderName.length > 0;
    }

    onCvvInfo() {
        this.cvvInfoVisible = true;
        window.addEventListener("click", this.handleCvvInfoOutsideClick);
    }

    onCvvInfoFocusOut() {
        console.log("onCvvInfoFocusOut");
    }

    async handleFormSubmit() {
        try {
            this.error = null;
            this.setGlobalLoading();
            const payload = await this.hostedFields.submit({ contingencies: ["3D_SECURE"], cardholderName: this.cardHolderName });
            console.log("@@@@@@@@@@@@@@@@");
            console.log(payload);
            console.log("@@@@@@@@@@@@@@@@");
            if (AUTHENTICATION_REASONS_MAP[`${payload.AUTHENTICATION_REASONS_MAP}`] === true) {
                const data = await this.$tinabaAPI.$vas.confirmPaypalCheckout({ ...payload, externalTransactionId: payload.orderId });
                console.log("@@@@@@@@@@@@@@@@");
                console.log(data);
                console.log("@@@@@@@@@@@@@@@@");
                await this.triggerPoll();
            } else {
                this.error = this.$t("greeting-error");
            }
        } catch (error) {
            if (error && error.response && error.response.data.error) {
                this.error = error.response.data.error;
            } else {
                this.error = this.$t("greeting-error");
            }
        } finally {
            this.unsetGlobalLoading();
        }
    }

    initPaypal() {
        window.paypal.HostedFields.render({
            styles: {
                input: {
                    "font-size": "17px",
                    "font-family": "bulorounded, helvetica, tahoma, calibri, sans-serif",
                    color: "#6f7f89",
                },
                ":focus": {
                    color: "black",
                },
            },
            locale: getformattedLocale(),
            createOrder: (data: any, actions: any) => {
                return this.$tinabaAPI.$vas.createPaypalCheckout(this.payment.id, "CARD").then((data) => {
                    console.log("@@@@@@@@@@@@@@@@");
                    console.log(data);
                    console.log("@@@@@@@@@@@@@@@@");
                    if (data.message) {
                        console.log(data.message);
                        return null;
                    }
                    return data.externalTransactionId;
                });
            },
            fields: {
                number: {
                    selector: "#card-number",
                    placeholder: "Numero carta",
                },
                cvv: {
                    selector: "#cvv",
                    placeholder: "CVV",
                },
                expirationDate: {
                    selector: "#expiration-date",
                    placeholder: "MM/AAAA",
                },
            },
            onInit: (data: any, actions: any) => {
                this.paypalActions = actions;
            },
            onError: (error: any) => {
                this.processing = false;
            },
            onCancel: (data: any, actions: any) => {
                this.processing = false;
            },
        }).then((hostedFields: any) => {
            this.hostedFields = hostedFields;

            hostedFields.on("validityChange", (event: any) => {
                console.log("validityChange", event);
                this.isPaypalDataValid = event.fields.cvv.isValid && event.fields.expirationDate.isValid && event.fields.number.isValid;
            });
        });
    }

    handleCvvInfoOutsideClick(e : any) {
        let elBtnCvvInfo = this.$refs.btnCvvInfo as HTMLElement;
        if (e.target instanceof HTMLElement && !elBtnCvvInfo.contains(e.target)) {
            this.cvvInfoVisible = false;
            window.removeEventListener("click", this.handleCvvInfoOutsideClick);
        }
    }

    mounted() {
        this.initPaypal();

    }
}
